.loading {
  width: 100%;
  display: flex;
  text-align: center;
  min-height: 400px;
}
.loading img {
  margin: auto;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL3RtcC9idWlsZF9mNmVhODkyMC9hcHAvamF2YXNjcmlwdC9jb21wb25lbnRzL2NvbW1vbi9Mb2FkaW5nIiwic291cmNlcyI6WyJMb2FkaW5nLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRTtFQUNBO0VBQ0E7RUFDQTs7QUFDQTtFQUNFIiwic291cmNlc0NvbnRlbnQiOlsiLmxvYWRpbmcge1xuICB3aWR0aDogMTAwJTtcbiAgZGlzcGxheTogZmxleDtcbiAgdGV4dC1hbGlnbjogY2VudGVyO1xuICBtaW4taGVpZ2h0OiA0MDBweDtcbiAgaW1nIHtcbiAgICBtYXJnaW46IGF1dG87XG4gIH1cbn1cbiJdfQ== */